import classNames from 'classnames'
import { useMemo, useState } from 'react'
import { Link } from 'react-router-dom'
import fontStyles from 'src/assets/styles/fontStyles.module.scss'
import generalStyles from 'src/assets/styles/generalStyles.module.scss'
import DropdownFilterBtn from 'src/components/Elements/DropdownFilterBtn'
import ExchangeBusinessCardButton from 'src/components/Elements/ExchangeBusinessCardButton'
import UserRow from 'src/components/Elements/UserRow'
import { useGlobalContext } from 'src/stores/GlobalContext'
import { ConditionalWrapper } from 'src/utils/ConditionalWrapper'
import userStyles from './userStyles.module.scss'

const attendessOpt = [
  {
    label: 'Connected With',
    id: 'connections',
    icon: 'Tick'
  },
  {
    label: 'Governing Body',
    id: 'gbs',
    icon: 'GoverningBody'
  },
  {
    label: 'Speaker',
    id: 'speakers',
    icon: 'Speaker'
  }
]

const gbsOpt = [
  { label: 'Co-chair', id: 'chairs' },
  { label: 'Member', id: 'members' }
]

const UserList = ({ users, userType }) => {
  const { currentEvent } = useGlobalContext()
  const [filterSelected, setFilterSelected] = useState('all')
  const options = useMemo(() => {
    let arr = { header: 'profile tag', items: [{ label: 'all', id: 'all' }] }
    switch (userType) {
      case 'Attendees':
        arr = [{ ...arr, items: [...arr.items, ...attendessOpt] }]
        break
      case 'Governing Body Members':
        arr = [{ ...arr, items: [...arr.items, ...gbsOpt] }]
        break
      default:
        return [arr]
    }
    return arr
  }, [userType])

  const filteredUsers = useMemo(() => {
    switch (filterSelected) {
      case 'connections':
        return users.filter((u) => u.is_biz_card)
      case 'gbs':
        return users.filter((u) => u.is_gb)
      case 'speakers':
        return users.filter((u) => u.is_speaker)
      case 'chairs':
        return users.filter((u) => u.gb_is_featured)
      case 'members':
        return users.filter((u) => !u.gb_is_featured)
      default:
        return users
    }
  }, [filterSelected, users])

  const sections = [
    ...new Set(
      filteredUsers.map((a) => {
        return a.last_name[0].toLowerCase()
      })
    )
  ].map((title) => {
    return {
      title,
      data: filteredUsers.filter((a) => {
        return title.toLowerCase() === a.last_name[0].toLowerCase()
      })
    }
  })

  const handleScroll = (id) => {
    const element = document.getElementById('scrollable-container')
    const filterHeaderHeight = document
      .getElementById('filter-header')
      .getBoundingClientRect().height
    const top =
      document.getElementById(id).getBoundingClientRect().top +
      element.scrollTop -
      filterHeaderHeight -
      90
    element.scrollTo({ top })
  }

  const renderAlphaList = () => {
    const letters = []
    const alphabet = [
      'A',
      'B',
      'C',
      'D',
      'E',
      'F',
      'G',
      'H',
      'I',
      'J',
      'K',
      'L',
      'M',
      'N',
      'O',
      'P',
      'Q',
      'R',
      'S',
      'T',
      'U',
      'V',
      'W',
      'X',
      'Y',
      'Z'
    ]
    alphabet.forEach((letter) => {
      if (sections.map((s) => s?.title.toUpperCase()).includes(letter)) {
        const section = sections.find((s) => s?.title.toUpperCase() === letter)
        letters.push(
          <button
            className={classNames(generalStyles.p0, userStyles.alphaButton)}
            key={letter}
            onClick={() => handleScroll(`section-scroll-to-${letter}`)}
          >
            <span
              className={fontStyles.pxsmallboldlsssin01lightbasegartnersans12pt}
            >
              {section?.title?.toUpperCase()}
            </span>
          </button>
        )
      } else {
        letters.push(
          <button
            className={classNames(generalStyles.p0, userStyles.alphaButton)}
            key={letter}
            disabled
            style={{ cursor: 'auto' }}
          >
            <span
              key={letter}
              className={fontStyles.pxsmallboldlsssgartnersans12pt}
              style={{ opacity: 0.25 }}
            >
              {letter}
            </span>
          </button>
        )
      }
    })
    return <div className={userStyles.alphaList}>{letters}</div>
  }

  return (
    <div className={classNames(generalStyles.thirdWidth, generalStyles.pb50)}>
      <div id="filter-header" className={userStyles.filterHeader}>
        <div
          style={{
            backgroundColor: '#ffffff',
            borderLeft: 'solid 40px white',
            borderRight: 'solid 40px white',
            marginLeft: '-40px',
            marginRight: '-40px'
          }}
        >
          <div className={generalStyles.pt40}>
            {userType !== 'Speakers' && (
              <DropdownFilterBtn
                options={options}
                onSelect={(filter) =>
                  setFilterSelected(filter['profile tag'].id)
                }
              />
            )}
            {userType === 'Attendees' &&
              currentEvent.is_attended &&
              !currentEvent.is_virtual_event && (
                <div className={generalStyles.mb20}>
                  <ExchangeBusinessCardButton sublabel="Exchange Virtual Business Cards" />
                </div>
              )}
            {renderAlphaList()}
          </div>
        </div>
      </div>

      <div style={{ marginTop: '31px' }}>
        {sections?.map((section) => {
          return (
            <div style={{ marginTop: '10px' }} key={section?.title}>
              <div
                id={`section-scroll-to-${section?.title?.toUpperCase()}`}
                style={{
                  backgroundColor: '#002869',
                  padding: '10px',
                  display: 'flex',
                  alignItems: 'center',
                  marginTop: '10px',
                  marginBottom: '10px',
                  maxHeight: '20px'
                }}
              >
                <span className={fontStyles.h5lsinneutral01whitegartnersans20pt}>
                  {section?.title?.toUpperCase()}
                </span>
              </div>
              {section?.data?.map((attendee, i, array) => (
                <div
                  key={attendee?.id}
                  style={{ marginBottom: '0px', maxHeight: '60px' }}
                >
                  <button
                    key={attendee?.id}
                    className={classNames(
                      generalStyles.p10,
                      generalStyles.leftAlignedText,
                      {
                        [generalStyles.userRowButton]: userType === 'Attendees'
                      }
                    )}
                    style={{
                      marginLeft: '-10px',
                      maxHeight: '60px',
                      display: 'flex',
                      alignItems: 'center',
                      width: 'calc(100% + 20px)'
                    }}
                    disabled={userType !== 'Attendees'}
                  >
                    <ConditionalWrapper
                      condition={userType === 'Attendees'}
                      wrapper={(children) => (
                        <Link
                          to={`/programs/${currentEvent.id}/attendees/${attendee?.user_id}`}
                        >
                          {children}
                        </Link>
                      )}
                    >
                      <UserRow
                        user={attendee}
                        includeIcons={true}
                        isSmallPhoto={true}
                      />
                    </ConditionalWrapper>
                  </button>
                  <div
                    className={classNames({
                      [generalStyles.ml10]: array?.length !== i + 1
                    })}
                  ></div>
                </div>
              ))}
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default UserList
